import { Box, SxProps, Theme } from '@mui/material';
import React, { FC, memo, useEffect, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

interface Props {
  defaultValues?: any;
  onSubmit: any;
  sx?: SxProps<Theme>;
  resetValues: boolean;
}

export const Form: FC<Props> = memo((props) => {
  const methods = useForm({
    defaultValues: useMemo(() => {
      return props.defaultValues;
    }, [props]),
  });
  useEffect(() => {
    if (props.resetValues && props.defaultValues) {
      methods.reset(props.defaultValues);
    }
  }, [props, methods]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(props.onSubmit)}>
        <Box sx={{...props.sx, display: 'flex', flexDirection: 'column'}}>{props.children}</Box>
      </form>
    </FormProvider>
  );
});
